export default function DinercapModalBody(props) {
    const { children } = props;
    return <div className="m-0">{children}</div>;
}
